import { Selected } from '../components/filter/props';

export function includesInArray(
  array: Array<Selected>,
  arrayToCompare: Array<string>
): Array<Selected> {
  if (array && array.length) {
    var filteredKeywords = array.filter((item: Selected) =>
      arrayToCompare.includes(item.value)
    );

    return filteredKeywords;
  }

  return [];
}
